export default __webpack_public_path__ + "media/color/hodl-e61456c0.svg";